import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import './registerServiceWorker'

// Import Bootstrap first (base styles)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import custom styles last (to override Bootstrap)
import './stylesheets/_variables.scss'
import './stylesheets/index.scss'
import './stylesheets/icons.scss'

// Import modern Google Font
const link = document.createElement('link')
link.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap'
link.rel = 'stylesheet'
document.head.appendChild(link)

 

createApp(App).
use(router).
use(store).
mount('#app')
